export type StatTileTone = 'default' | 'mint' | 'red' | 'gold'

interface StatTileProps {
  value: string
  caption: string
  tone?: StatTileTone
  title?: string
}

const TONE_CLASSES: Record<StatTileTone, string> = {
  default: 'text-text',
  mint: 'text-mint',
  red: 'text-red',
  gold: 'text-gold'
}

/** Stort tal + billedtekst. Bruges til rekorder og profil-fliser. */
function StatTile({ value, caption, tone = 'default', title }: StatTileProps) {
  return (
    <div className="rounded-[10px] border border-text-2/20 bg-text-2/10 px-2.5 py-2" title={title}>
      <b className={`block truncate font-display text-base ${TONE_CLASSES[tone]}`}>{value}</b>
      <span className="text-[9px] uppercase tracking-[0.04em] text-text-2">{caption}</span>
    </div>
  )
}

export default StatTile
